const getters = {
    getBiayaOutletList: (state) => state.biayaOutletList,
    getBiayaOutletDetail: (state) => state.biayaOutletDetail,
    getPagination: (state) => state.pagination,
    getSearch: (state) => state.search,
    getIsSearch: (state) => state.isSearch,
    getQueryBiayaOutletList: (state) => state.queryBiayaOutletList,
    getScrollPosition: (state) => state.scrollPosition,
};

export default getters;
